'use client';

import { Button } from '@instamenu/ui-system-next';
import { useParams, usePathname, useRouter } from 'next/navigation';

export function TipButton() {
  const { orderId } = useParams();
  const router = useRouter();
  const pathname = usePathname();
  const basePath = pathname?.startsWith('/orders-payment-link/')
    ? '/orders-payment-link'
    : '/orders';

  return (
    <Button
      variant="secondary"
      size="xs"
      css={{ marginLeft: 10 }}
      data-id="edit-tip"
      onClick={() => router.push(`${basePath}/${orderId}/tip`)}
    >
      Edit
    </Button>
  );
}
